export default __webpack_public_path__ + "static/media/spinner.df082c79.gif";